import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'replaceWhitespaceWithHyphen',
})
export class ReplaceWhitespaceWithHyphenPipe implements PipeTransform {
  transform(value: string): string {
    return value.replaceAll(' ', '-');
  }
}
